import React, { Component } from 'react'

import EventCard from './EventCard'
import EventDetail from './EventDetail'
import EventData from './EventData'

class GenericEvent extends Component {
  render() {
    const { isNote, iconSrc, eventLabel, event, endUser, actionTaker, campaign } = this.props
    const cardProps = { isNote, iconSrc }
    const detailProps = { eventLabel, event, endUser, actionTaker }
    const dataProps = { isNote, event, campaign }
    return (
      <EventCard {...cardProps}>
        <EventDetail {...detailProps}>
          {this.props.children}
        </EventDetail>
        <EventData {...dataProps}/>
      </EventCard>
    )
  }
}

export default GenericEvent



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/GenericEvent.js